import Vue from 'vue';
import * as VueFire from 'vuefire';
import * as firebase from 'firebase';
import 'firebase/database';
import 'firebase/firestore';
import Ads from 'vue-google-adsense';
import Meta from 'vue-meta';
import router from './router';
import App from './App.vue';
import './registerServiceWorker';
import store from './store';
import vuetify from './plugins/vuetify';

const script2 = require('vue-script2');

const firebaseConfig = {
  apiKey: 'AIzaSyBpdLO3LUPliCox7oQ3VTcQy0uiPRt9S90',
  authDomain: 'movilist-d1b82.firebaseapp.com',
  databaseURL: 'https://movilist-d1b82.firebaseio.com',
  projectId: 'movilist-d1b82',
  storageBucket: 'movilist-d1b82.appspot.com',
  messagingSenderId: '67309915685',
  appId: '1:67309915685:web:7e30be40e0ea5f337839cc',
  measurementId: 'G-C6SQ6DPZDH',
};
firebase.initializeApp(firebaseConfig);
Vue.prototype.$firebase = firebase;
Vue.prototype.$auth = firebase.auth();
Vue.config.productionTip = false;

Vue.use(VueFire);
Vue.use(script2);
Vue.use(Meta);
Vue.use(Ads.Adsense);
Vue.use(Ads.InArticleAdsense);
Vue.use(Ads.InFeedAdsense);

new Vue({
  store,
  vuetify,
  router,
  render: (h) => h(App),
}).$mount('#app');
